import { createFileRoute } from '@tanstack/react-router'

import CertificatePersonalize from '@/certificate/components/CertificatePersonalize'

export const Route = createFileRoute(
  '/_learning/_my-learning/certificate/$certificateId/personalize',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const certificateId = Route.useParams({ select: (p) => p.certificateId })

  return <CertificatePersonalize certificateId={certificateId} />
}
